define('instrumentation/log', [
    'instrumentation/activityManager',
    'instrumentation/log-category',
    'instrumentation/log-level'
], function (activityManager, LOGCATEGORY, LOGLEVEL) {

    function logMessage (methodName, message, scenarioName, logCategory, logLevel) {
        activityManager.logMessage(
            message,
            methodName,
            [logCategory ? logCategory : LOGCATEGORY.TRACE],
            logLevel ? logLevel : LOGLEVEL.INFO,
            scenarioName ? activityManager.getActivityId(scenarioName) : undefined
        );
    }

    return {
        trace: function (methodName, message, scenarioName) {
            logMessage(methodName, message, scenarioName, LOGCATEGORY.TRACE);
        },

        error: function (methodName, message, scenarioName) {
            logMessage(methodName, message, scenarioName, LOGCATEGORY.ERROR);
        },

        verbose: function (methodName, message, scenarioName) {
            logMessage(methodName, message, scenarioName, LOGCATEGORY.TRACE, LOGLEVEL.VERBOSE);
        },

        perf: function(metric, value, scenarioName) {
            logMessage(metric, value, scenarioName, LOGCATEGORY.PERFORMANCE);
        },

        startScenario: function (scenarioName, message) {
            return activityManager.start(scenarioName, false, true, message);
        },

        endScenario: function (scenarioName, result, message) {
            return activityManager.endByScenarioName(scenarioName, result, message);
        },

        pageRouteStart: function (pagePath, viewName, previousPath, previousView) {
            return activityManager.logPageRouteStart(pagePath, viewName, previousPath, previousView);
        },

        pageRoutePageLoadDuration: function (pagePath, loadDuration, isRecorded) {
            return activityManager.logPageRouteNavigationDuration(pagePath, loadDuration, isRecorded);
        },

        pageRouteEnd: function (pagePath, viewName, activityId, stayDuration, nextPagePath, isUnload) {
            return activityManager.logPageRouteEnd(pagePath, viewName, activityId, stayDuration, nextPagePath, isUnload);
        },

        flushLogs: function (callback) {
            activityManager.flushLogs(callback);
        },

        logError: function (methodName, message) {
            this.error(methodName, message, null);
        }
    };
});
